import { API_BASE_URL } from './apiConfig';
import { handleUnauthorized } from './authApi';

const getAuthHeaders = () => {
  const token = sessionStorage.getItem('casapizza_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Fetches active orders from the kitchen dashboard endpoint.
 * 
 * @returns {Promise<Array>} Array of active orders
 * @throws {Error} If the request fails
 */
/**
export async function fetchActiveOrders() {
  try {
    const response = await fetch(`${API_BASE_URL}/panel/orders/active`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    // The API returns { orders: [...] }
    return data.orders || [];
  } catch (error) {
    console.error('Error fetching active orders:', error);
    throw error;
  }
}*/

export const fetchActiveOrders = async (branchId) => {
  const response = await fetch(
    `${API_BASE_URL}/panel/orders/active?branch_id=${branchId}`,
    { headers: getAuthHeaders() }
  );
  if (!response.ok) {
    if (response.status === 401) handleUnauthorized();
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

/**
 * Updates the status of an order.
 * 
 * @param {number} orderId - The ID of the order to update
 * @param {string} newStatus - The new status (PENDING, PREPARING, READY, etc.)
 * @returns {Promise<Object>} Updated order data
 */
export async function updateOrderStatus(orderId, newStatus) {
  try {
    const response = await fetch(`${API_BASE_URL}/panel/orders/${orderId}/status`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ status: newStatus })
    });
    
    if (!response.ok) {
      if (response.status === 401) handleUnauthorized();
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating order status:', error);
    throw error;
  }
}